import { Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Bot, LogOut, Crown, Shield, Megaphone, Link2 } from "lucide-react";
import { BuzzlyLogo } from "@/components/BuzzlyLogo";
import { useAuth } from "@/lib/auth";
import { UserAvatar } from "@/components/UserAvatar";

const STATUS = { trialing: "Essai gratuit", active: "Abonné Pro", past_due: "Paiement en retard", canceled: "Résilié", none: "Sans abonnement" };

export function AppNav({ current }) {
  const { user, signOut } = useAuth();
  const nav = useNavigate();
  const link = (to, label, Icon, key) => (
    <Link to={to} data-testid={`nav-${key}`}
      className={`inline-flex shrink-0 items-center gap-1.5 px-2 sm:px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${current === key ? "bg-[#e7f3ff] text-[#1877f2]" : "text-[#65676b] hover:bg-[#f0f2f5]"}`}>
      <Icon className="w-4 h-4" /> <span className="hidden sm:inline">{label}</span>
    </Link>
  );
  return (
    <div className="relative z-20 bg-white border-b border-[#dddfe2]" data-testid="app-nav">
      <div className="max-w-[1440px] mx-auto px-4 lg:px-10 h-14 flex items-center gap-3">
        <BuzzlyLogo to="/app" />
        <nav className="flex items-center gap-0.5 sm:gap-1 ml-1 sm:ml-2 min-w-0 overflow-x-auto [scrollbar-width:none]">
          {link("/app", "Dashboard", LayoutDashboard, "dashboard")}
          {link("/app/agent", "Mon agent", Bot, "agent")}
          {link("/app/link", "Depuis un lien", Link2, "link")}
          {link("/app/spot", "Spot pub", Megaphone, "spot")}
          {user?.role === "admin" && link("/app/admin", "Admin", Shield, "admin")}
        </nav>
        <div className="ml-auto flex items-center gap-1 sm:gap-2 shrink-0">
          <span className="chip chip-fb hidden md:inline-flex" data-testid="subscription-chip">
            {user?.role === "admin" ? <><Crown className="w-3 h-3" /> Admin</> : STATUS[user?.subscription_status] || user?.subscription_status}
          </span>
          <Link to="/app/profile" title="Mon profil" data-testid="nav-profile"
            className={`inline-flex items-center gap-2 rounded-full pl-1 pr-1 lg:pr-3 py-1 transition-colors ${current === "profile" ? "bg-[#e7f3ff]" : "hover:bg-[#f0f2f5]"}`}>
            <UserAvatar user={user} size={32} testId="nav-avatar" />
            <span className="text-xs font-semibold text-[#050505] truncate max-w-[140px] hidden lg:inline" data-testid="nav-user-email">{user?.name || user?.email}</span>
          </Link>
          <button type="button" onClick={() => { nav("/"); setTimeout(signOut, 0); }} className="btn-ghost !px-3 !py-2" data-testid="logout-btn" title="Déconnexion">
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
